import Footer from "./footer";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import BounceLoader from "react-spinners/BounceLoader";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";

const Contacts = () => {
  const [phone, setPhone] = useState(260);
  const [name, setName] = useState();
  const [message, setMessage] = useState();
  const [email, setEmail] = useState();
  const [loading, setLoading] = useState(0);
  const navigate = useNavigate();
  const topRef = useRef(null);

  useEffect(() => {
    topRef.current.scrollIntoView({ behavior: "smooth" });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(1);

    axios

      .post("https://farmserver.pickmesms.com/loanmsg", {
        name: name,
        email: email,
        message: message,
        phone: phone,
      })
      .then((res) => {
        setLoading(0);
        if (res.data.result === 200) {
          swal({
            text: "We have got your message",
            icon: "success",
          }).then(() => {
            navigate("/");
          });
        }
      })
      .catch((err) => {
        // console.log(err);
        swal({
          text: "An Error occured. Please contact support",
          icon: "warning",
        });
        setLoading(0);
      });
  };

  return (
    <>
      <section ref={topRef} className="contact-one">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="contact-one__content">
                <div className="block-title">
                  <p className="small-title">Get in touch with us</p>
                  <h2 className="title-block">Ask for your query</h2>
                </div>
                <div className="contact-one__box">
                  <i className="pylon-icon-telephone" />
                  <div className="contact-one__box-content">
                    <h4>Call Anytime</h4>
                    <a href="tel:+260779244370">+260779244370</a>
                  </div>
                  {/* /.contact-one__box-content */}
                </div>
                {/* /.contact-one__box */}
                <div className="contact-one__box">
                  <i className="pylon-icon-email1" />
                  <div className="contact-one__box-content">
                    <h4>Write Email</h4>
                    <a href="info@centuryloans.net">info@centuryloans.net</a>
                  </div>
                  {/* /.contact-one__box-content */}
                </div>
                {/* /.contact-one__box */}
                <div className="contact-one__box">
                  <i className="pylon-icon-pin1" />
                  <div className="contact-one__box-content">
                    <h4>Visit Office</h4>
                    <a href="#">
                      Plot No 6479, Mugoti Road Roma, Lusaka - Zambia
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-7">
              <form onSubmit={handleSubmit} className="contact-one__form">
                <div className="row low-gutters">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        placeholder="Your Name"
                        className="form-control contact-one__form-input"
                        name="name"
                        required=""
                        onChange={(e) => setName(e.target.value)}
                        value={name}
                      />
                    </div>
                  </div>
                  {/* /.col-md-6 */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        placeholder="Your Email"
                        className="form-control contact-one__form-input"
                        name="email"
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                        required=""
                      />
                    </div>
                  </div>
                  {/* /.col-md-6 */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        placeholder="Phone Number"
                        className="form-control contact-one__form-input"
                        name="phone"
                        onChange={(e) => setPhone(e.target.value)}
                        value={phone}
                      />
                    </div>
                  </div>
                  {/* /.col-md-6 */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        placeholder="Subject"
                        className="form-control contact-one__form-input"
                        name="subject"
                      />
                    </div>
                  </div>
                  {/* /.col-md-6 */}
                  <div className="col-md-12">
                    <div className="form-group">
                      <textarea
                        name="message"
                        placeholder="Write Message"
                        className="contact-one__form-input"
                        defaultValue={""}
                        onChange={(e) => setMessage(e.target.value)}
                        value={message}
                      />
                    </div>
                    {loading === 1 ? (
                      <div className="col-md-12" style={{ float: "right" }}>
                        <div className="form-group">
                          <BounceLoader
                            size={35}
                            color={"#808080"}
                            loading={true}
                          />
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <button className="thm-btn" type="submit">
                      Send A Message
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      <div className="bottom-footer">
        <div className="container">
          <p>© Copyright 2022 by Century Loans</p>
        </div>
        {/* /.container */}
      </div>
      {/* /.bottom-footer */}

      <div className="mobile-nav__wrapper">
        <div className="mobile-nav__overlay mobile-nav__toggler" />
        {/* /.mobile-nav__overlay */}
        <div className="mobile-nav__content">
          <span className="mobile-nav__close mobile-nav__toggler" />
          <div className="logo-box">
            <a href="#" aria-label="logo image">
              <img src="assets/images/logo-light.png" width={155} alt="" />
            </a>
          </div>
          {/* /.logo-box */}
          <div className="mobile-nav__container" />
          {/* /.mobile-nav__container */}
          <ul className="mobile-nav__contact list-unstyled">
            <li>
              <i className="pylon-icon-email1" />
              <a href="#">info@centuryloans</a>
            </li>
            <li>
              <i className="pylon-icon-telephone" />

              <a href="tel:+260779244370">+260779244370</a>
            </li>
          </ul>
        </div>
      </div>

      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <i className="fa fa-angle-up" />
      </a>
    </>
  );
};

export default Contacts;
